var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.05 139.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d1d1d1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.48,98.13c-1.21-5.18.69-9.74,2.16-14.39,2-6.34,4.87-12.4,6.21-19C11.27,52.94,10.14,41.61,4,31c-2.56-4.45-2.82-4.59,1.09-7.81,7.07-5.81,12.24-13.1,17-20.74C23.73,0,25.27-.4,28.06.79,37,4.6,46.25,7.1,56.13,5.72A28.07,28.07,0,0,0,65.72,2.4a5.88,5.88,0,0,1,6.09-.09A33.41,33.41,0,0,0,91.35,5.86,74,74,0,0,0,110.41.5c2.42-1,3.9-.55,5.23,1.73a80.84,80.84,0,0,0,19,22.59c1.51,1.22,1.44,2.47.51,3.92a47.84,47.84,0,0,0-4.75,9.58,48.15,48.15,0,0,0-2.48,18.14c.27,8.72,3.36,16.7,6.45,24.7a23.22,23.22,0,0,1,1.57,7.53c.23,6,.13,12,0,18-.24,9.06-7.56,18.82-16.16,21.8-8.76,3-17.79,4-27,4.25a51.67,51.67,0,0,0-16.63,2.81,11.71,11.71,0,0,0-4.73,3.16c-1.51,1.67-3.18,1.75-4.75.13-3.65-3.77-8.45-4.72-13.31-5.52-6.34-1-12.78-.73-19.14-1.39s-12.51-1.62-18.28-4.49A24.07,24.07,0,0,1,3.64,113.94C1.7,108.79-1.14,103.85.48,98.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.be77c23f1fc7fb8cc3e983f9482c50b0.svg";
export { ForwardRef as ReactComponent };